import Vue from 'vue'
import App from '@/App'
import router from '@/router'

import DetectApp from '@/plugins/DetectApp'
import Animator from '@/plugins/Animator'
import ScreenSize from '@/plugins/ScreenSize'
import VueGtag from 'vue-gtag'

Vue.use(DetectApp)
Vue.use(Animator)
Vue.use(ScreenSize)
Vue.use(VueGtag, {
	config: {
		id: process.env.VUE_APP_GA_ID,
		params: {
			send_page_view: false
		}
	}
})

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
